import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '../providers';
import { getHasUserAndCompany } from '../store';

export function useRequireUserAndCompany() {
  const location = useLocation();
  const {
    signInPathname
  } = useAuthContext();
  const redirectTo = useMemo(() => (signInPathname), [signInPathname]);
  const hasUserAndCompany = useSelector(getHasUserAndCompany);

  return {
    isBlocked: !hasUserAndCompany,
    location,
    redirectTo
  };
}

export default useRequireUserAndCompany;
